<div class="body-container-wrapper">
  <section class="retirement-home-page-banner p-0">
    <div class="container-fluid" style=" margin-bottom: 10px;">
      <div class="row align-items-start">
        <div class="col-md-8 col-sm-12">
          <div class="slider">
            <div class="slides">
              <div class="slide"><img src="../../../assets/images/khushiyon-ki-investment/Banner_1200x720-Desktop.jpg" alt="Slide 1"  (click)="desktopscroll()"  style="cursor: pointer;">
              </div>
              <div class="slide"><img src="../../../assets/images/khushiyon-ki-investment/Landing-page1-.jpg" alt="Slide 2"  (click)="desktopscroll()"  style="cursor: pointer;"></div>
              </div>
              </div>
              </div>
        <!-- Form Section -->
        <div class="col-md-4 col-sm-12">
          <div class="card banner-form">
            <div class="card-body" *ngIf="isLeadFormVisible">
              <h3 class="form-title">Fill the below form to initiate
                Khushiyon Ki Investment</h3>
              <p id="fill-form" style="color: #ed1b24; display: none;">Fill in all the details to proceed further.</p>
              <form #leadForm="ngForm" (ngSubmit)="PostData(leadForm)">
                <div class="form-group">
                  <label for="">Name<span class="asterisk"></span></label>
                  <input type="text" autocomplete="off" id="name" name="name" [(ngModel)]="name" class="form-control"
                    (blur)="removeErrorMsg('name')" placeholder="Please enter your full name" maxlength="40"
                    inputmode="text"
                    oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '').replace(/\s{2,}/g, ' ');"
                    (keydown)="alphaOnly($event)">
                  <div class="errormsg" *ngIf="nameValidateMessage == 'lengthError'">
                    Invalid full name
                  </div>
                  <div class="errormsg" *ngIf="nameValidateMessage == 'required'">
                    Full name is mandatory
                  </div>
                </div>
                <div class="form-group">
                  <label for="">Email Addresss </label>
                  <input type="text" autocomplete="off" (keydown.space)="$event.preventDefault();" id="email"
                    name="email" [(ngModel)]="email" class="form-control" placeholder="Your email id" maxlength="50"
                    (blur)="removeErrorMsg('email')">
                  <div class="errormsg" *ngIf="emailValidateMessage == 'invalid'">
                    Invalid email id
                  </div>
                  <div class="errormsg" *ngIf="emailValidateMessage == 'required'">
                    Email id is mandatory
                  </div>
                </div>
                <div class="form-group">
                  <label for="">Mobile Number<span class="asterisk"></span></label>
                  <input type="text" (keydown.space)="$event.preventDefault();" autocomplete="off" id="mobile"
                    name="mobile" [(ngModel)]="mobile" class="form-control" placeholder="Enter Your mobile number"
                    minlength="10" maxlength="10" pattern="[6789][0-9]{9}" (blur)="removeErrorMsg('mobile')"
                    inputmode="numeric" oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                    (keypress)="numbersOnly($event)">
                  <div class="errormsg" *ngIf="mobileValidateMessage == 'lengthError'">
                    10 digit mobile number is mandatory
                  </div>
                  <div class="errormsg" *ngIf="mobileValidateMessage == 'invalid'">
                    Invalid mobile number
                  </div>
                  <div class="errormsg" *ngIf="mobileValidateMessage == 'required'">
                    Mobile number is mandatory
                  </div>
                </div>

                <div class="form-group">
                  <label for="">City <span class="asterisk"></span></label>
                  <input type="text" autocomplete="off" id="city" name="city" [(ngModel)]="city" class="form-control"
                    placeholder="Your city" maxlength="40" (keydown)="alphaOnly($event)" (blur)="removeErrorMsg('city')"
                    inputmode="text"
                    oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '').replace(/\s{2,}/g, ' ');">

                  <div class="errormsg" *ngIf="cityValidateMsg == 'required'">
                    City is mandatory
                  </div>
                </div>

                <div class="form-group">
                  <label for="">Pincode <span class="asterisk"></span></label>
                  <input type="text" autocomplete="off" id="pincode" name="pincode" [(ngModel)]="pincode"
                    class="form-control" placeholder="Your pincode" pattern="^[1-9][0-9]{5}$" minlength="6"
                    maxlength="6" (click)="openSuggestionBox($event,'form')" (blur)="hideSuggestionDiv('form')"
                    (keyup)="getPincodeList($event,'form')" (keypress)="numberspincode($event)">
                  <div class="errormsg" *ngIf="pinValidateMessage== 'invalid'">
                    Invalid pincode
                  </div>
                  <div class="errormsg" *ngIf="pinValidateMessage == 'required'">
                    Pincode is mandatory
                  </div>
                  <div class="errormsg" *ngIf="pinValidateMessage == 'notselected'">
                    Pincode selection from the list is mandatory
                  </div>

                  <div class="suggestion-box" id="suggestion-box" *ngIf="hideSuggestion">
                    <ng-container *ngFor="let pin of pincodeArr">
                      <a class="pointer" (mousedown)="setpincode(pin,'form')">
                        <div style="padding:10px;">{{pin.pincode}} - {{pin.cityname}}</div>
                      </a>
                    </ng-container>
                  </div>
                </div>



                <div class="form-group">
                  <label for="">Current Age</label>
                  <input type="text" class="form-control" placeholder="Enter in years" id="currentAge"
                    [(ngModel)]="currentAge" name="currentAge" autocomplete="off"
                    (blur)="removeErrorMsg('currentage')" minlength="" maxlength="3"
                    (keypress)="numberspincode($event)">
                  <div class="errormsg" *ngIf="currAgeValidateMessage == 'invalid'">
                    Current age is not valid
                  </div>
                  <div class="errormsg" *ngIf="currAgeValidateMessage == 'required'">
                    Current age is mandatory
                  </div>
                </div>
                <div class="text-left position-relative pl-3">
                  <input type="checkbox" class="form-check-input checkbox2" id="checkout1" [(ngModel)]="checkedTerms"
                    name="check" />
                  <small class="whatsappcontent">
                    By continuing to use this Site/Page, you acknowledge and consent to receiving promotional or
                    sales-related communications from BajajCapital Group. These communications may be sent via phone
                    calls, SMS, WhatsApp, or email, using the contact details you have provided on the Site/Page.
                  </small>
                </div>
                <div class="text-center">
                  <button type="submit" class="btn btn-primary" [disabled]="!checkedTerms"
                    (click)="checkValidationMsg(leadForm)">Submit</button>
                </div>
              </form>
            </div>
            <div class="card-body otp-card" *ngIf="isOtpFormVisible">
              <div id="main_loader" style="display:none;">
                <div class="loader-wrapper">
                  <div class="lds-roller">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </div>
              <form #otpForm="ngForm" (ngSubmit)="SubmitOTP(otpForm)">
                <p><a href="javascript:void(0)" id="btn-back" (click)="changeNumber()"><i
                      class="fa fa-chevron-left"></i> Change Number</a></p>
                <div class="alert alert-success">
                  <i class="fa fa-check"></i>
                  <span>OTP successfully sent on number {{displayMobile}}</span>
                </div>
                <div class="form-group">
                  <input type="text" autocomplete="off" (keydown.space)="$event.preventDefault();"
                    (keyup)="removeErrorMsg('otp')" id="otp" name="otp" [(ngModel)]="userOTP" class="form-control"
                    maxlength="6" placeholder="Enter OTP" (keypress)="numberspincode($event)">
                  <div class="errormsg" *ngIf='!otpVerifiedStatus'>
                    Invalid OTP
                  </div>
                  <div class="errormsg" *ngIf="otpValidateMessage == 'required'">
                    Please enter OTP to continue.
                  </div>
                  <div class="errormsg" *ngIf="otpValidateMessage == 'lengthError'">Invalid OTP
                  </div>
                </div>
                <div class="text-center">
                  <button type="submit" class="btn btn-primary" id="otp_verify_btn"
                    (click)="otpValidate()">Submit</button>
                </div>
                <div class="form-group text-center">
                  <span *ngIf="isTimer">Didn't recieve OTP? Resend in <strong style="font-size:17px;">{{timeleft}}
                    </strong>seconds</span>
                  <a class="resendotp" href="javascript:void(0)" *ngIf="isResend" (click)="resendOTP()">Resend OTP</a>
                </div>
              </form>
            </div>
            <div class="card-body success-card" *ngIf="isThanksVisible">
              <div class="success-tick">
                <h2>Thank you!</h2>
              </div>
              <h6>{{ thanksMessage }}</h6>
            </div>

          </div>
        </div>
        <!-- old form end  -->
      </div>
    </div>
  </section>

  <!-- Calendar Popup Modal -->
  <div class="calendar-popup-overlay" *ngIf="isCalendarPopupVisible">
    <div class="calendar-popup-content" (click)="$event.stopPropagation()">
      <div class="calendar-popup-header">
        {{ isalreadyBooked ? 'THANKYOU!' : 'Schedule Your Consultation' }}
        <button class="close-btn" (click)="closeCalendarPopup()">&times;</button>
      </div>

       
      <div class="calendar-popup-body" *ngIf="isalreadyBooked"> 
  <h4>
    Your appointment has been fixed. We will call you on 
    {{appointmentDate}} at {{appointmentTime}}.
  </h4>
</div>

      <div class="calendar-popup-body" *ngIf="!isalreadyBooked">
        <!-- Date Selection -->
        <div class="calendar-selection-wrapper">
          <div class="date-selection-section">
            <h4>Select Date</h4>

            <!-- Calendar Header -->
            <div class="calendar-header">
              <div class="calendar-nav">
                <button class="nav-btn" (click)="previousMonth()">
                  <i class="fa fa-chevron-left"></i>
                </button>
                <span class="current-month-year">{{currentMonth.format('MMMM YYYY')}}</span>

                <button class="nav-btn" (click)="nextMonth()">
                  <i class="fa fa-chevron-right"></i>
                </button>
              </div>
            </div>

            <!-- Calendar Grid -->
            <div class="calendar-grid">
              <!-- Days of Week Header -->
              <div class="calendar-weekdays">
                <div class="weekday" *ngFor="let day of ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']">
                  {{day}}
                </div>
              </div>

              <!-- Calendar Days -->
              <div class="calendar-days">
                <div *ngFor="let day of calendarDays" class="calendar-day" [class.current-month]="day.isCurrentMonth"
                  [class.other-month]="!day.isCurrentMonth" [class.today]="day.isToday" [class.selected]="day.isSelected"
                  [class.disabled]="day.isDisabled" [class.available]="day.isAvailable"
                  (click)="selectCalendarDate(day)">
                  {{day.date.format('D')}}
                </div>
              </div>
            </div>

            <!-- Calendar Actions -->
            <div class="calendar-actions">
              <button class="clear-btn" (click)="clearSelection()">CLEAR</button>
            </div>
          </div>

          <!-- Time Slot Selection -->
          <div class="time-selection-section" [class.has-selection]="!!selectedDate" *ngIf="selectedDate">
            <div class="time-selection-header">
              <h4>Select Time Slot</h4>
            </div>
            <div class="time-slots">
              <div *ngFor="let timeSlot of availableTimeSlots" class="time-slot"
                [class.selected]="selectedTimeSlot === timeSlot" (click)="selectTimeSlot(timeSlot)">
                {{timeSlot}}
              </div>
            </div>

            <!-- Confirm Button -->
            <div class="popup-actions" *ngIf="isAppointmentReady()">
              <p class="_popmsg">{{popupmessage}}</p>
              <button class="btn btn-primary confirm-btn" (click)="confirmAppointment()" [disabled]="isButtonDisabled">
                Confirm Appointment
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

</div>

<!-- old form end  -->



<section class="landing-page-sections">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12">
        <div class="section-heading new">
          <h2>KYUKI YEH HAI MERI FAMILY KI <i style="color: #ed1b24;text-transform: capitalize;">#KhushiyonKiInvestment</i></h2>
          </div>
          </div>
          </div>
          </div>
          </section>


<section class="landing-page-sections new">
  <div class="container">
    <div class="row justify-content-center text-center mb-4">
      <!-- Career Goals -->
      <div class="col-md-6 col-lg-3">
        <div class="goal-card text-start">
          <img src="../../../assets/images/khushiyon-ki-investment/Image-1.png" alt="Career Goals" class="img-fluid mb-3">
          <h3 class="text-danger mb-3">INVEST FOR <br> CHILDREN’S CAREER GOALS</h3>
          <div style="text-align: left;padding: 0px 15px;font-size: 13px !important;">
            <ul class="list-unstyled">
              <li class="goal-list">Turn their dreams into a clear career path.</li>
              <li class="goal-list">Plan for their skills, higher education, and growth.</li>
              <li class="goal-list"> Build a Strong Foundation for Their Future.</li>
            </ul>
          </div>
          <a class="click-btn" (click)="interest('Career')" [class.active]="interestValues.includes('Career')">
            <span class="default-text">Yes, I'm Interested</span>
            <span class="hover-text">Yes, I'm Interested</span>
          </a>
        </div>
      </div>
      <!-- Married Life Goals -->
      <div class="col-md-6 col-lg-3">
        <div class="goal-card text-start">
          <img src="../../../assets/images/khushiyon-ki-investment/Image-2.png" alt="Married Life Goals" class="img-fluid mb-3">
          <h3 class="text-danger mb-3">INVEST FOR <br> MARRIED LIFE GOALS</h3>
          <div style="text-align: left;padding: 0px 15px;">
            <ul class="list-unstyled">
              <li class="goal-list">Use responsibilities to fuel progress.</li>
              <li class="goal-list">Secure today, enjoy <br>tomorrow.</li>
              <li class="goal-list">Achieve dreams with confidence.</li>
            </ul>
          </div>
          <a class="click-btn" (click)="interest('Married')" [class.active]="interestValues.includes('Married')">
            <span class="default-text">Yes, I'm Interested</span>
            <span class="hover-text">Yes, I'm Interested</span>
          </a>
          </div>
          </div>
          <!-- Family Goals -->
          <div class="col-md-6 col-lg-3">
            <div class="goal-card text-start">
              <img src="../../../assets/images/khushiyon-ki-investment/Image-3.png" alt="Family Goals" class="img-fluid mb-3">
              <h3 class="text-danger mb-3">INVEST FOR <br> FAMILY GOALS</h3>
              <div style="text-align: left;padding: 0px 15px;">
                <ul class="list-unstyled">
                  <li class="goal-list">Secure your family’s future.</li>
                  <li class="goal-list">Turn your children’s dreams into milestones.</li>
                  <li class="goal-list">Build financial strength<br> for every stage of their<br> journey.</li>
                </ul>
              </div>
              <a class="click-btn" (click)="interest('Family')" [class.active]="interestValues.includes('Family')">
                <span class="default-text">Yes, I'm Interested</span>
                <span class="hover-text">Yes, I'm Interested</span>
              </a>
            </div>
          </div>
          <!-- Retirement Goals -->
          <div class="col-md-6 col-lg-3">
            <div class="goal-card text-start">
              <img src="../../../assets/images/khushiyon-ki-investment/Image-4.png" alt="Retirement Goals" class="img-fluid mb-3">
              <h3 class="text-danger mb-3">INVEST FOR <br> RETIREMENT GOALS</h3>
              <div style="text-align: left;padding: 0px 15px;">
                <ul class="list-unstyled">
                  <li class="goal-list">Retirement is a new beginning.</li>
                  <li class="goal-list">Enjoy freedom to pursue your dreams.</li>
                  <li class="goal-list">Leave a legacy of security and fulfillment.</li>
                </ul>
              </div>
              <a class="click-btn" (click)="interest('Retirement')" [class.active]="interestValues.includes('Retirement')">
                <span class="default-text">Yes, I'm Interested</span>
                <span class="hover-text">Yes, I'm Interested</span>
              </a>
            </div>
          </div>
          </div>
          </div>
          </section>


<section class="landing-page-sections bg-gray">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12">
        <div class="section-heading">
          <h2>THE ROADMAP TO <i style="color: #ed1b24;text-transform: capitalize;">#KhushiyonKiInvestment</i></h2>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="landing-page-sections bg-gray">
  <div class="container">
    <div class="row justify-content-center text-center mb-4">
      <!-- Career Goals -->
      <div class="col-md-6 col-lg-3">
        <div class="goal-card text-start">
          <img src="../../../assets/images/khushiyon-ki-investment/icon-1.png" alt="Career Goals" class="img-fluid mb-3">
          <h3 class="text-danger mb-3">MANIFEST</h3>
          <div style="text-align: left;padding: 0px 15px;" class="desc">
            Think of Your Life Goals and at what stages you want to achieve those
          </div>
        </div>
      </div>
      <!-- Married Life Goals -->
      <div class="col-md-6 col-lg-3">
        <div class="goal-card text-start">
          <img src="../../../assets/images/khushiyon-ki-investment/icon-2.png" alt="Married Life Goals" class="img-fluid mb-3">
          <h3 class="text-danger mb-3">EXECUTE</h3>
          <div style="text-align: left;padding: 0px 15px;" class="desc">
            Create a defined financial strategy specific to each life goal and lay down a strategic path to achieve
            them
          </div>
        </div>
      </div>
      <!-- Family Goals -->
      <div class="col-md-6 col-lg-3">
        <div class="goal-card text-start">
          <img src="../../../assets/images/khushiyon-ki-investment/icon-3.png" alt="Family Goals" class="img-fluid mb-3">
          <h3 class="text-danger mb-3">HARNESS</h3>
          <div style="text-align: left;padding: 0px 15px;" class="desc">
            Keep the portfolio updated with regular rebalancing and life goals at their defined time
          </div>
          </div>
      </div>
      <!-- Retirement Goals -->
      <div class="col-md-6 col-lg-3">
        <div class="goal-card text-start">
          <img src="../../../assets/images/khushiyon-ki-investment/icon-4.png" alt="Retirement Goals" class="img-fluid mb-3">
          <h3 class="text-danger mb-3">ACHIEVE</h3>
          <div style="text-align: left;padding: 0px 15px;" class="desc">
            Connect to Initiate your Khushiyon Ki Investment
          </div>
        </div>
      </div>
      </div>
      </div>
      </section>


<section class="landing-page-sections">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12">
        <div class="sapno-ki-udaan">
          <h2>LIFE GOALS-SECURED WITH <i style="color: #ed1b24;text-transform: capitalize;">#KhushiyonKiInvestment</i>
          </h2>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="landing-page-sections" style="padding: 0 !important;overflow: hidden;">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12" style="padding: 0;">
        <img src="../../../assets/images/khushiyon-ki-investment/Bottom-Banner.jpg" alt="Financial Goals Banner 6"
          class="img-fluid landing-banner desktop">
        <img src="../../../assets/images/khushiyon-ki-investment/Bottom-Banner-mobile.jpg" alt="Financial Goals Banner 6"
          class="img-fluid landing-banner mobile">
      </div>
    </div>
  </div>
</section>

<section class="landing-page-sections desktop-banner">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12" (click)="scroll()" style="cursor: pointer;">
        <img src="../../../assets/images/khushiyon-ki-investment/Connect-Now.jpg" alt="Financial Goals Banner 4"
          class="img-fluid landing-banner">
      </div>
    </div>
  </div>
</section>

<section class="landing-page-sections mobile-banner">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12" (click)="scroll()" style="cursor: pointer;">
        <img src="../../../assets/images/Sapno-Ki-Udaan-Landing-page_Banner-4_mobile.jpg" alt="Financial Goals Banner 4"
          class="img-fluid landing-banner mobile-banner-img">
      </div>
    </div>
  </div>
</section>


<div class="container">
  <p class="col-md-12 mt-3 terms"> <span style="font-weight: bold;">Disclaimer: </span>Bajaj Capital Limited (BCL)
    (CIN: U67120DL1965PLC004338) is a mutual fund distributor (ARN 0010) registered with AMFI. Registered Office:
    Mezzanine Floor, Bajaj House 97, Nehru Place, New Delhi-110019.
    <b>Mutual Fund investments are subject to market risks, read all scheme-related documents carefully.</b> Certain
    products and services offered by BCL may not be traded on the exchange. All disputes with respect to the
    distribution activity, would not have access to Exchange Investor Redressal Forum or Arbitration mechanism. In
    accordance with the applicable laws, BCL is allowed to render incidental advice with respect to mutual fund
    products only to its mutual fund distribution clients. For every other purpose, including distribution of
    non-mutual fund products, the circulated material is for informational purposes only. Further,
    it is not intended as investment advice or an opinion concerning securities or a public offer proving a basis for
    an investment decision. The views or expressions contained in the circulated material are not necessarily of BCL
    and BCL neither assumes any responsibility/liability nor does guarantee its accuracy, suitability, completeness
    and adequacy. Thefigures and data that may be appearing in the material are taken from various sources and BCL is
    not responsible for the accuracy of the same. The content of the material including images, charts, graphics and
    pictures are protected intellectual properties and cannot be amended, copied, reproduced, replicated, republished,
    uploaded, posted, published, transmitted, displayed or distributed for any non-personal use without obtaining
    prior written permission, any non-adherence of which may attract appropriate legal action. The past performance of
    the scheme is not indicative of future performance. Investors are advised to seek appropriate advice from experts
    before taking any investment decisions. Nothing in the circulated material is intended to construe an
    advertisement or an investment, financial advice and/or solicitation, advice to buy, sell or deal in any financial
    product.
    </p>
    </div>
    
    <div class="new-section">
      <p>www.BajajCapital.com</p>
    </div>